import React from 'react';
import type { ViewStyle } from 'react-native';
import { View } from 'react-native';

type PositionType = 'bl' | 'br' | 'tl' | 'tr';

type Props = {
  size: number;
  color?: string;
  type: PositionType;
};

const positionCalculators: Record<PositionType, (size: number) => ViewStyle> = {
  tl: (size) => ({
    top: -size / 2,
    left: -size / 2,
  }),
  tr: (size) => ({
    top: -size / 2,
    right: -size / 2,
  }),
  bl: (size) => ({
    bottom: -size / 2,
    left: -size / 2,
  }),
  br: (size) => ({
    bottom: -size / 2,
    right: -size / 2,
  }),
};

/** Removes a small notch that is painted on intersections of departments at the inner corners of the map. */
export function NotchEraser({ size, color = 'white', type }: Props) {
  const position = positionCalculators[type](size);
  const style: ViewStyle = {
    position: 'absolute',
    backgroundColor: color,
    width: size,
    height: size,
    ...position,
  };

  return <View style={style} />;
}
